import {  TimerObservable  } from '/druid/TimerObservable';

export const timer = TimerObservable.create;